<template>
    <div class="content">
        <div class="bg profile-view" v-bind:style="{ 'background-image': 'url(' + pics.bg_user_login + ')' }">
            <h3>请完善个人信息</h3>
            <h4 class="phone-info">当前绑定手机号码：{{signUpPhone| mask("phone")}}</h4>
            <div class="signup-box">
                <div class="signup-form">
                    <van-field v-model="name" placeholder="请填写您的真实姓名" label="姓名" />
                    <van-field readonly clickable name="picker" :value="idType.text" label="证件类型" placeholder="请选择"
                        :is-link="true" @click="showIdTypePicker = true" />
                    <van-popup v-model="showIdTypePicker" position="bottom">
                        <van-picker show-toolbar :columns="idTypes" @confirm="onSelectIdType"
                            @cancel="showIdTypePicker = false" />
                    </van-popup>
                    <van-field v-model="idcard" center clearable placeholder="请输入有效证件号码" label="证件号码">
                    </van-field>
                    <!-- <van-field v-model="marital" center clearable placeholder="请选择" label="婚姻状况">
                    </van-field> -->
                    <van-field name="radio" label="性别" v-if="idType.value != 0">
                        <template #input>
                            <van-radio-group v-model="sex" direction="horizontal">
                                <van-radio :name="1">男</van-radio>
                                <van-radio :name="2">女</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field readonly clickable v-model="birth" placeholder="必填" label="出生日期"
                        @click="showDatePicker=true" v-if="idType.value != 0" />
                    <van-popup v-model="showDatePicker" position="bottom">
                        <van-datetime-picker type="date" title="选择出生日期" :min-date="minDate" :max-date="maxDate"
                            :value="currentDate" @confirm="onConfirmDate" @cancel="showDatePicker = false" />
                    </van-popup>
                    <van-field readonly clickable name="picker" :value="marital.text" label="婚姻状况" placeholder="请选择"
                        :is-link="true" @click="showMaritalPicker = true" />
                    <van-popup v-model="showMaritalPicker" position="bottom">
                        <van-picker show-toolbar :columns="maritalStatus" @confirm="onSelectMarital"
                            @cancel="showMaritalPicker = false" />
                    </van-popup>
                    <!-- <div style="height:25px"></div> -->
                    <van-field v-model="password" type="password" center clearable
                        :placeholder="passwordSetting.passwordTips" label="输入密码">
                    </van-field>
                    <van-field v-model="password2" type="password" center clearable placeholder="请再次确认密码" label="确认密码">
                    </van-field>
                    <div class="field-border"></div>
                </div>
                <div class="signup-footer">
                    <van-button type="info" size="large" @click="signup()">立即注册</van-button>
                    <!-- <span class="signup">已有账号登录</span> -->
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    body {
        background: #fff;
    }

    .content {
        height: 100vh;
        overflow: hidden;
        background: #fff;

        .bg {
            background: url("../../assets/images/bg-login.png") no-repeat top center;
            background-size: 100% auto;
        }

        .profile-view {
            padding-top: 7vh;
            padding-left: 20px;
            padding-right: 20px;
        }

        h3 {
            font-size: 22px;
            text-align: left;
        }

        .phone-info {
            color: #9F9F9F;
            font-size: 14px;
        }
    }

    .signup-box {
        background: #fff;
        text-align: center;

        /deep/.van-tab {
            font-size: 16px;
        }

        .signup-form {
            padding: 20px 0px;

            .field-border ::after {
                position: absolute;
                box-sizing: border-box;
                content: " ";
                pointer-events: none;
                right: 0;
                bottom: 0;
                left: 16px;
                border-bottom: 1px solid #ebedf0;
                -webkit-transform: scaleY(0.5);
                transform: scaleY(0.5);
            }

            .van-cell {
                // display: block;
                padding: 10px 0;
                height: 50px;
            }

            /deep/ .van-field__label {
                text-align: left;
            }

            /deep/ .van-cell:not(:last-child)::after {
                left: 0;
            }
        }

        .signup-footer {
            padding: 0 20px;

            .signup {
                display: block;
                margin: 20px 0;
                color: #169bd5;
                font-size: 16px;
            }
        }
    }
</style>

<script>
    import moment from 'moment';
    import {
        checkPhoneNumber,
        checkIdCard,
        getSex,
        getBirthday,
        isStrongPassword
    } from "@/libs/validate-utils";
    import {
        pics
    } from '@/libs/common'
    import * as lib_auth from '@/libs/auth';
    import {
        mapState,
        mapMutations,
        mapActions
    } from 'vuex'
    import {
        addUser
    } from '@/api/user';
    import {
        Toast
    } from 'vant';
    export default {
        data() {
            return {
                pics,
                idcard: "",
                sms: "",
                name: "",
                marital: "",
                password: "",
                password2: "",
                sex: 1,
                birth: "",
                showIdTypePicker: false,
                showMaritalPicker: false,
                showDatePicker: false,
                maritalStatus: [{
                        text: '未婚',
                        value: "0"
                    },
                    {
                        text: '已婚',
                        value: "1"
                    },
                    {
                        text: '其它',
                        value: "2"
                    },
                ],
                idType: {
                    text: '身份证',
                    value: 0
                },
                idTypes: [{
                        text: '身份证',
                        value: 0
                    },
                    {
                        text: '护照',
                        value: 1
                    },
                    {
                        text: '港澳台通行证/居住证',
                        value: 2
                    },
                    {
                        text: '其它证件',
                        value: 3
                    },
                ],
                minDate: new Date(1920, 1, 1),
                maxDate: new Date(2020, 1, 1),
                currentDate: new Date(1980, 1, 1),
                passwordSetting: {
                    securityLevel: 0,
                    passwordTips: '长度8位或以上'
                },
            };
        },
        computed: {
            ...mapState({
                signUpPhone: state => state.user.signUpPhone,
                openId: state => state.user.openId,
                configs: state => state.hospital.configs
            })
        },
        methods: {
            ...mapActions("user", {
                setPhone: "signUpPhone"
            }),
            async signup() {
                if (!this.checkProfile()) {
                    return;
                }
                let birthday = this.birth.replace(/-/g, '');
                let params = {
                    "hospId": this.$route.query.hospid,
                    "name": this.name,
                    "idType": this.idType.value,
                    "idcard": this.idcard,
                    "mobile": this.signUpPhone,
                    "password": this.password,
                    "sex": this.sex,
                    "birth": birthday,
                    "marital": this.marital.value,
                    "openId": this.openId,
                    "sign": this.$route.query.sign
                };
                let result = await addUser(params);
                console.log(result);
                if (result.code == 200) {
                    //清除注册用的手机号
                    this.setPhone("");
                    //保存用户信息到localStorage
                    lib_auth.setUser(result.data);
                    this.$router.replace("/");
                } else {
                    Toast.fail(result.msg);
                }
            },
            onSelectIdType(item) {
                this.idType = item;
                this.showIdTypePicker = false;
            },
            onConfirmDate(date) {
                console.log(date);
                this.birth = moment(date).format("YYYY-MM-DD");
                this.showDatePicker = false;
            },
            checkProfile() {
                if (this.name == "") {
                    Toast("请输入姓名");
                    return false;
                }
                if (this.idcard == '') {
                    Toast("请输入证件号码");
                    return false;
                }
                if (this.idType.value == 0) {
                    if (checkIdCard(this.idcard) > 0) {
                        Toast("请填写正确的身份证号");
                        return false;
                    } else {
                        this.sex = parseInt(getSex(this.idcard));
                        this.birth = getBirthday(this.idcard);
                    }
                } else {
                    //校验性别和出生日期
                    if (this.sex !== 1 && this.sex !== 2) {
                        Toast("请选择性别")
                        return false;
                    }
                    if (this.birth == '') {
                        Toast("请选择出生日期")
                        return false;
                    }
                }
                if (this.password == "" || this.password.length < 8) {
                    Toast("密码长度需要设置为8位或以上");
                    return false;
                }
                if (this.password !== this.password2) {
                    Toast("密码输入不一致")
                    return false;
                }
                let pwdResult = isStrongPassword(this.password, this.passwordSetting.securityLevel);
                if (!pwdResult.result) {
                    this.$Toast("密码不符合安全等级要求：" + this.passwordSetting.passwordTips);
                    return false;
                }
                return true;
            },
            onSelectMarital(item) {
                console.log(item);
                this.marital = item;
                this.showMaritalPicker = false;
            }
        },
        mounted() {
            //判断store是否存在注册信息
            if (!this.signUpPhone || this.signUpPhone == "") {
                this.$router.push("/signup");
            }

            //获取密码等级配置
            if (this.configs && this.configs.length) {
                var config = this.configs.find(it => {
                    return it.code == "user_password_level"
                });
                if (config && config.value) {
                    this.passwordSetting = {
                        securityLevel: parseInt(config.value),
                        passwordTips: config.detail_note
                    }
                }
            }
        },

    };
</script>